import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, filter, map, Observable, throwError } from 'rxjs';
import { RoutesMapper } from '../../routes-mapper';
interface RequestOptions {
  params?: { [key: string]: any };
  body?: { [key: string]: any };
  headers?: { [key: string]: any };
}
interface RequestPayload {
  params?: { [key: string]: any };
  body?: { [key: string]: any };
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  private createHeaders(): HttpHeaders {
    let authorizationToken: string = localStorage.getItem('AccessToken') || '';
    let headers: { [key: string]: string } = {
      Authorization: `Bearer ${authorizationToken}`,
    };

    let httpHeaders = new HttpHeaders();
    if (headers) {
      for (const key in headers) {
        httpHeaders = httpHeaders.set(key, headers[key]);
      }
    }
    return httpHeaders;
  }

  private createParams(params?: { [key: string]: any }): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      for (const key in params) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return httpParams;
  }

  replacePathInfo(route: string, pathInfo?: { [key: string]: any }): string {
    if (pathInfo) {
      const replaceableKeys = Object.keys(pathInfo);
      for (const key of replaceableKeys) {
        const str = '{' + key + '}';
        route = route.replace(str, pathInfo[key]);
      }
    }
    return route;
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage: string = '';
    console.log('api error', error);

    // if (error.error instanceof ErrorEvent) {
    //   errorMessage = `An error occurred: ${error.error.message}`;
    // } else if (error.error.data == undefined || error.error.data.length == 0) {
    //   errorMessage = error.error.message;
    // } else {
    //   errorMessage = error.error.message; // use error.status and error.message to get the error details
    // }
    errorMessage = error.error.message;

    console.log(errorMessage);
    if (error.status === 401) {
      localStorage.clear();
      this.router?.navigate([RoutesMapper.LOGIN]);
    }
    //  else if (error.status === 403) {
    //   this.router.navigate([RoutesMapper.UNAUTHORIZED]);
    // }
    return throwError(errorMessage);
  }

  request<T>(
    method: string,
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication?: boolean,
    responseType: 'json' | 'blob' = 'json'
  ): Observable<T> {
    let httpOptions: any = {
      body: options?.body,
      params: this.createParams(options?.params),
    };

    if (requiresAuthentication) {
      httpOptions['headers'] = this.createHeaders();
    }

    const req = new HttpRequest<T>(method, endpoint, httpOptions.body, {
      headers: httpOptions.headers,
      params: httpOptions.params,
      responseType: responseType
    });

    return this.http.request<T>(req).pipe(
      filter(
        (event): event is HttpResponse<T> => event instanceof HttpResponse
      ),
      map((response: HttpResponse<T>) => response.body as T),
      catchError(this.handleError.bind(this))
    );
  }

  get<T>(
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication: boolean = true,
    responseType: 'json' | 'blob' = 'json'
  ): Observable<T> {
    return this.request<T>('GET', endpoint, options, requiresAuthentication, responseType);
  }

  post<T>(
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication: boolean = true
  ): Observable<T> {
    return this.request<T>('POST', endpoint, options, requiresAuthentication);
  }
  put<T>(
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication: boolean = true
  ): Observable<T> {
    return this.request<T>('PUT', endpoint, options, requiresAuthentication);
  }
  delete<T>(
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication: boolean = true
  ): Observable<T> {
    return this.request<T>('DELETE', endpoint, options, requiresAuthentication);
  }
  patch<T>(
    endpoint: string,
    options?: RequestOptions,
    requiresAuthentication: boolean = true
  ): Observable<T> {
    return this.request<T>('PATCH', endpoint, options, requiresAuthentication);
  }
}
